/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import $ from 'jquery'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Select from 'react-select'
import SearchProduct from '../BaseComponent/SearchProduct'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import AutoComplete from '../BaseComponent/autocomplete'

class PurchaseCustomer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      providerId: '',
      loading: false,
      Providers: [],
      comboProvides: [],
      printInfo: [],
      lengthProviders: 0,
      pageNumber: 1,
      providerArr: [],
      providers: [],
      finalStocks: [],
      pageSize: 10,
      countAll: 0,
      sortBy: '',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام',
          value: 'name',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نام کاربری',
          value: 'username',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'کد مشتری',
          value: 'userCode',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تاریخ آخرین خرید',
          value: 'lastPurchaseDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'مدت زمان عدم خرید (روز)',
          value: 'lastPurchaseDateCount',
          sorted: false,
          direction: null,
          sortable: true
        }
      ]
    }
  }

  componentDidMount() {
    // http
    //   .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
    //   .then(response => {
    //     if (response.data.error == null) {
    //       var provider = response.data.object;
    //       for (let i = 0; i < provider.length; i++) {
    //         provider[i]["value"] = provider[i].providerId;
    //         provider[i]["label"] =
    //           provider[i].providerId + " - " + provider[i].title;
    //       }

    //       this.setState({
    //         providers: response.data.object
    //       });
    //     } else {
    //       this.setState({
    //         providers: []
    //       });
    //     }
    //   });

    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  getPurchase = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_CUSTOMER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            Providers: response.data.object.result,
            min: lastPurchaseDayCountMin,
            max: lastPurchaseDayCountMax,
            lengthProviders: response.data.object.countAll,
            buttonClicked: true,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            Providers: [],
            lengthProviders: 0,
            loading: false
          })
          // message.error(response.data.description)
        }
      })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getPurchase(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getPurchase(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getPurchase(false)
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  onResultFetched(data) {
    this.setState({
      Providers: data
    })
  }

  changeDropDown(data) {
    this.setState({
      Providers: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let {providerArr, finalStocks, providerId} = this.state
    var lastPurchaseDayCountMin = document.getElementById('lastPurchaseDayCountMin').value.trim()
    var lastPurchaseDayCountMax = document.getElementById('lastPurchaseDayCountMax').value.trim()
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (finalStocks.length !== '') {
      filter.stockProductIds = finalStocks.join(',')
    }

    if (lastPurchaseDayCountMin !== '') {
      filter.lastPurchaseDayCountMin = lastPurchaseDayCountMin.trim()
    }

    if (lastPurchaseDayCountMax !== '') {
      filter.lastPurchaseDayCountMax = lastPurchaseDayCountMax.trim()
    }
    if (providerId) {
      filter.providerIds = providerId
    }

    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getPurchase(false)
        }
      )
    }
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_CUSTOMER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['lastPurchaseDate'] = jMoment(excelReport[i]['lastPurchaseDate']).format('jYY/jMM/jDD HH:mm')
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)
    this.setState({
      loading: true
    })

    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_CUSTOMER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            loading: false
          })
          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  handleChangeProvider = (multiProvider) => {
    var providerArr = []
    this.setState({multiProvider})
    if (multiProvider.length == '0') {
      this.setState({
        providerArr: []
      })
    } else {
      for (let prop of multiProvider) {
        providerArr.push(prop.providerId)
        this.setState({
          providerArr: providerArr
        })
      }
    }
  }

  getStocks = (arrayOfStocks) => {
    var stockArr = []

    this.setState({
      arrayOfStocks
    })

    if (arrayOfStocks.length == '0') {
      this.setState({
        finalStocks: []
      })
    } else {
      for (let prop of arrayOfStocks) {
        stockArr.push(prop.value)
        this.setState({
          finalStocks: stockArr
        })
      }
    }
  }

  finalStocks = (finalStocks) => {
    let array = []
    finalStocks.forEach((item) => {
      array.push(item.stockProductId)
    })
    this.setState({
      finalStocks: array
    })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    let excelColumns = [
      {title: 'نام تامین کننده', value: 'title'},
      {title: 'شناسه تامین کننده', value: 'providerId'},
      {title: 'کد ملی', value: 'nationalId'},
      {title: 'کد اقتصادی', value: 'economicCode'}
    ]
    let name = cookie.load('name')
    let columns = ['ردیف', 'نام', 'نام کاربری', 'کد مشتری', 'تاریخ آخرین خرید', 'مدت زمان عدم خرید(روز)']
    let urlParams = sessionStorage.getItem('params')

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش عدم خرید مشتریان"
              headerColSpan={6}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={1}
              centerColSpan={2}
              centerSection={''}
              rightSection={' تعداد روز از : ' + this.state.min + ' تا : ' + this.state.max}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.customer.name}</td>
                  <td>{item.customer.username === null ? '' : item.customer.username.replace(/\+98/g, '0')}</td>
                  <td>{item.customer.userCode}</td>
                  <td>{jMoment(item.lastPurchaseDate).format('jYYYY/jMM/jDD HH:mm')}</td>
                  <td>{item.lastPurchaseDayCount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش عدم خرید مشتریان.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'title'}
                field={'customer.name'}
                title={'نام'}
                width="250px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'providerId'}
                field={'customer.username'}
                title={'نام کاربری'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'nationalId'}
                field={'customer.userCode'}
                title={'کد مشتری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'economicCode'}
                field={'lastPurchaseDate'}
                title={'تاریخ آخرین خرید'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'economicCode'}
                field={'lastPurchaseDayCount'}
                title={'مدت زمان آخرین خرید(روز)'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>خرید و فروش</li>
            <li>عدم خرید مشتریان</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/report/purchase/customer'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>حداقل روز</label>
                  <input type="text" className="form-control" id="lastPurchaseDayCountMin" />
                </div>
                <div className="formComponent">
                  <label>حداکثر روز</label>
                  <input type="text" className="form-control" id="lastPurchaseDayCountMax" />
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>تامین کننده ها :</label>
                  <Select
                    value={this.state.multiProvider}
                    onChange={this.handleChangeProvider}
                    options={this.state.providers}
                    isMulti={true}
                    isClearable={true}
                    placeholder=""
                  /> */}
                </div>
              </div>
              <div>
                <SearchProduct getStocks={this.getStocks} finalStocks={this.finalStocks} />
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.Providers.map((providers, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{providers.customer.name}</td>
                      <td>
                        {providers.customer.username === null ? '' : providers.customer.username.replace(/\+98/g, '0')}
                      </td>
                      <td>{providers.customer.userCode}</td>
                      <td>{jMoment(providers.lastPurchaseDate).format('jYYYY/jMM/jDD HH:mm')}</td>
                      <td>{providers.lastPurchaseDayCount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthProviders}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PurchaseCustomer
